module.exports = __webpack_public_path__ + "static/media/dish.574e6ade.png";